import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { MAX_CURRENCY, MAX_CURRENCY_FUTURE_ADJUSMENTS } from "../../shared/constants";
import { currencyFormatNoDecimals } from "../../shared/shared";

const CurrencyCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const minAmount = (field === "costBasis" && dataItem.taxType && dataItem.taxType === "PRE-TAX") ? 0 : 1;

  if (!dataItem.inEdit) {
    return <td>
      {currencyFormatNoDecimals(dataValue)}
    </td>
  }

  return (
    <td >
      <NumericTextBox
        label={" "}
        value={dataValue}
        onChange={handleChange}
        format={"c0"}
        min={0}
        max={MAX_CURRENCY}
        valid={dataValue >= minAmount && dataValue <= MAX_CURRENCY}
      />
    </td>
  );
};

const CurrencyCellMaxAmountFutureAdjustments = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (dataItem.isAccountRothConversionIntoFIA && dataItem.conversionType === "ALL")
    return <td></td>

  if (!dataItem.inEdit) {
    return <td>
      {currencyFormatNoDecimals(dataValue)}
    </td>
  }

  return (
    <td >
      <NumericTextBox
        label={" "}
        value={dataValue}
        onChange={handleChange}
        format={"c0"}
        min={0}
        max={MAX_CURRENCY_FUTURE_ADJUSMENTS}
        valid={dataValue >= 1 && dataValue <= MAX_CURRENCY_FUTURE_ADJUSMENTS}
      />
    </td>
  );
};

const RothIRACurrencyCellMaxAmountFutureAdjustments = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (dataItem.conversionType === "ALL")
    return <td></td>

  if (!dataItem.inEdit) {
    return <td>
      {currencyFormatNoDecimals(dataValue)}
    </td>
  }

  return (
      <td >
        <NumericTextBox
            label={" "}
            value={dataValue}
            onChange={handleChange}
            format={"c0"}
            min={0}
            max={MAX_CURRENCY_FUTURE_ADJUSMENTS}
            valid={dataValue >= 1 && dataValue <= MAX_CURRENCY_FUTURE_ADJUSMENTS}
        />
      </td>
  );
};

export { CurrencyCell, CurrencyCellMaxAmountFutureAdjustments, RothIRACurrencyCellMaxAmountFutureAdjustments };
